exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mod[data-v-55c8e5bc] {\n  width: max-content;\n  color: #8888FF;\n  margin: auto;\n}\n.crafted[data-v-55c8e5bc] {\n  color: #b4b4ff;\n}\n", ""]);

// exports
